import React, { Component } from "react";
import { BootstrapInput } from "app/components/common/BootStrapInput";
import BarChart from "app/components/charts/BarChart";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import StackedBarChart from "./StackedBarChart";
import JobTypeDropdown from "app/components/common/JobTypeDropdown";

import { FormControl, MenuItem, Select, Typography, InputBase, ListSubheader } from "@mui/material";

class AgeJobCounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
    };
    this.searchInputRef = React.createRef();
  }

  handleSearchChange = (event) => {
    event.stopPropagation();
    this.setState({ searchText: event.target.value });
  };

  handleDropdownOpen = () => {
    if (this.searchInputRef.current) {
      this.searchInputRef.current.focus();
    }
  };

  handleKeyDown = (event) => {
    if (event.key !== 'Enter') {
      event.preventDefault();
      if (this.searchInputRef.current) {
        this.searchInputRef.current.focus();
      }
    }
  };

  addPropsToSeriesCountChart(series) {
    let colors = ["#6AA4DC"];
    return series.map((el, i) => ({
      ...el,
      color: colors[i],
      borderColor: colors[i],
    }));
  }

  render() {
    let totalCount = this.props.countData["data"].reduce((a, b) => a + b, 0);

    let age_data = [
      {
        name: "Age wise job count",
        data: this.props.countData["data"],
      },
    ];

    let minCountData = 0;
    let maxCountData = 1000;
    let countTickInterval = 100;
    if (this.props.countData["data"]) {
      minCountData = Math.min(...this.props.countData["data"]);
      minCountData = parseFloat(minCountData.toFixed(2));

      maxCountData = Math.max(...this.props.countData["data"]);
      maxCountData = parseFloat(maxCountData.toFixed(2));

      countTickInterval = parseInt(
        Math.abs(Math.abs(maxCountData) - Math.abs(minCountData)) / 10
      );
    }

    let countIntervalPower = String(countTickInterval).length;
    countTickInterval =
      parseFloat((countTickInterval / Math.pow(10, countIntervalPower - 1)).toFixed(2)) *
      Math.pow(10, countIntervalPower - 1);

    const filteredOptions = this.props.occupationTypes.filter(name =>
      name.toLowerCase().includes(this.state.searchText.toLowerCase())
    );

    return (
      <div className="graph-wrapper screen-left-graph-container">
        <div className="graph-title-container-screen graph-title-container-screen3">
          <div className="graph-dropdown graph-dropdown-4">
            <FormControl sx={{ width: "290px", marginTop: "20px" }}>
              {/* <Typography variant="inherit" className="form-metrics-header">
                Occupation
              </Typography> */}
              <Select
                value={this.props.occupationTypeSelected}
                onChange={this.props.handleOccupationTypeChange}
                onOpen={this.handleDropdownOpen}
                onKeyDown={this.handleKeyDown}
                input={<BootstrapInput />}
                inputProps={{ "aria-label": "Without label" }}
                // MenuProps={{ PaperProps: { sx: { maxHeight: "400px" } } }}
                className="select-mui"
                displayEmpty
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,

                  PaperProps: {
                    sx: { maxHeight: "400px" },
                  },
                }}
              >
                <MenuItem disabled value="">
                  <Typography variant="inherit" noWrap>
                    Select an Occupation
                  </Typography>
                </MenuItem>
                <ListSubheader>
                  <InputBase
                    placeholder="Search..."
                    value={this.state.searchText}
                    onChange={this.handleSearchChange}
                    onKeyDown={e => e.stopPropagation()}
                    inputRef={this.searchInputRef}
                    fullWidth
                  />
                </ListSubheader>
                {filteredOptions.map((name, i) => (
                  <MenuItem key={i} value={name}>
                    <Typography variant="inherit" noWrap>
                      {name}
                    </Typography>
                  </MenuItem>
                ))}
                {/* {this.props.occupationTypes.length
                  ? this.props.occupationTypes.map((name, i) => (
                      <MenuItem key={i} value={name}>
                        <Typography variant="inherit" noWrap>
                          {name}
                        </Typography>
                      </MenuItem>
                    ))
                  : null} */}
              </Select>
            </FormControl>
          </div>
          <JobTypeDropdown></JobTypeDropdown>
        </div>
        <div className="graph-screen graph-screen3">
          <div className="graph-title" style={{ paddingBottom: "20px" }}>Age Distribution</div>
          {this.props.countData ? (
            <StackedBarChart
              containerId="stackChart"
              stacking="normal"
              remainingOptions={{
                chart: {
                  animation: false,
                  type: "bar",
                  backgroundColor: "transparent",
                  height: 605,
                  width: 700,
                  spacingTop: 20,
                  marginRight: 20,
                  dataLabels: false,
                },
                series: this.addPropsToSeriesCountChart(age_data),
                xAxis: {
                  scrollbar: {
                    enabled: true,
                  },
                  categories: this.props.countData["labels"],
                  title: {
                    text: null,
                  },
                  labels: {
                    style: {
                      color: "#fff",
                      font: "normal normal normal 18px Arial",
                    },
                  },
                },
                yAxis: {
                  scrollbar: {
                    enabled: true,
                  },
                  offset: 10,
                  title: {
                    text: "Workers",
                    style: {
                      color: "#fff",
                      font: "normal normal normal 18px Arial",
                      letterSpacing: "0.49px",
                    },
                  },
                  labels: {
                    overflow: "justify",
                    style: {
                      color: "#fff",
                      font: "normal normal normal 18px Arial",
                    },
                  },
                  tickInterval: countTickInterval,
                  min: 0,
                  gridLineWidth: 0.5,
                },
                tooltip: {
                  borderRadius: 15,
                  borderWidth: 1,
                  borderColor: "#707070",
                  backgroundColor: "#FFFFFF",
                  padding: 17,
                  shape: "square",
                  style: {
                    font: "Arial",
                    fontSize: "14px",
                    color: "#333333",
                    lineHeight: 25,
                    zIndex: 999,
                  },
                  formatter() {
                    let response = `${this.key}: <b>${this.y.toLocaleString(
                      "en-US"
                    )}</b> ( ${parseFloat((
                      (this.y / totalCount) * 100
    ).toFixed(2))}% )<br/>`;
                    return response;
                  },
                },
                exporting: { enabled: false },
              }}
            />
          ) : (
            <div style={{ textAlign: "center", paddingTop: "400px" }}>
              {" "}
              No data available{" "}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function hasData(chartData) {
  let hasNodata = true;
  if (chartData.length == 0) {
    return false;
  }

  // chartData.forEach((elem) => {
  //   if (elem != null) {
  //     hasNodata = false;
  //   }
  // })
  return !hasNodata;
}

export default AgeJobCounts;
